import store from "../store";
import axios from "axios";

class Credentials {

    async getOne(uid) {
        let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/credentials/" + uid, {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data.credential);
				})
				.catch(function (error) {
					reject(error);
				});
		});
    }
	async getAll() {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/credentials", {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data.credentials);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async post(key, password, user) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/credentials",
					{
						key,
						password,
						user: user ? user : null
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data.credentials);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async put(uid, password) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.put(
					`${process.env.VUE_APP_SAAS_BACK}` + "/credentials",
					{
						uid,
						password,
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data.credentials);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async delete_key(uid) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.delete(`${process.env.VUE_APP_SAAS_BACK}` + "/credentials/" + uid, {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data.credentials);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}
}

export default new Credentials();
